export const getPolicyNavLinks = (t, clientId, tab) => {
    return [
        {
            title: t('Populations'),
            path: `/admin/clients/${clientId}/policies/populations`,
            selected: tab === 'populations',
        },
        {
            title: t('Workflows'),
            path: `/admin/clients/${clientId}/policies/workflows`,
            selected: tab === 'workflows',
        },
        {
            title: t('Rules'),
            path: `/admin/clients/${clientId}/policies/rules`,
            selected: tab === 'rules',
        },
        {
            title: t('Benefit Periods'),
            path: `/admin/clients/${clientId}/policies/benefit-periods`,
            selected: tab === 'benefit-periods',
        },
        {
            title: t('Filters'),
            path: `/admin/clients/${clientId}/policies/filters`,
            selected: tab === 'filters',
        },
    ];
};
export const getIntegrationsNavLinks = (t, clientId, tab) => {
    return [
        {
            title: t('Servers'),
            path: `/admin/clients/${clientId}/integrations/servers`,
            selected: tab === 'servers',
        },
        {
            title: t('Imports'),
            path: `/admin/clients/${clientId}/integrations/imports`,
            selected: tab === 'imports',
        },
        {
            title: t('Exports'),
            path: `/admin/clients/${clientId}/integrations/exports`,
            selected: tab === 'exports',
        },
        {
            title: t('Reports'),
            path: `/admin/clients/${clientId}/integrations/report-templates`,
            selected: tab === 'reports',
        },
    ];
};
export const getPayrollNavLinks = (t, clientId, tab) => {
    return [
        {
            title: t('Pending Payments'),
            path: `/admin/clients/${clientId}/payroll/pending`,
            selected: tab === 'pending',
        },
        {
            title: t('Generated Payrolls'),
            path: `/admin/clients/${clientId}/payroll/generated`,
            selected: tab === 'generated',
        },
    ];
};
